import { render, staticRenderFns } from "./ButtonScrollbar.vue?vue&type=template&id=0ffacf3c&"
import script from "./ButtonScrollbar.vue?vue&type=script&lang=ts&"
export * from "./ButtonScrollbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports